import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";
import {
  DEFAULT_NOMINEE_ADDRESS_DETAILS,
  DEFAULT_NOMINEE_PERSONAL_DETAILS,
} from "../../constants/nominee";

// Actions
const Actions = {
  getNominations: "getNominations",
  setNominations: "setNominations",
  updateNomineeDetails: "updateNomineeDetails",
  updateEquityNomineeData: "updateEquityNomineeData",
  createNomineeRequest: "createNomineeRequest",
  resetNomineeDetails: "resetNomineeDetails",
  updateNomineeRequest: "updateNomineeRequest",
  updateNomineeStatus: "updateNomineeStatus",
  updateNomineeStorage: "updateNomineeStorage",
  resetNomineeStorage: "resetNomineeStorage",
  setDocUploadConfig: "setDocUploadConfig",
};

export const getNominations = createAction(Actions.getNominations);
export const setNominations = createAction(Actions.setNominations);
export const updateNomineeDetails = createAction(Actions.updateNomineeDetails);
export const updateNomineeRequest = createAction(Actions.updateNomineeRequest);
export const resetNomineeDetails = createAction(Actions.resetNomineeDetails);
export const createNomineeRequest = createAction(Actions.createNomineeRequest);
export const updateNomineeStatus = createAction(Actions.updateNomineeStatus);
export const updateNomineeStorage = createAction(Actions.updateNomineeStorage);
export const resetNomineeStorage = createAction(Actions.resetNomineeStorage);
export const updateEquityNomineeData = createAction(
  Actions.updateEquityNomineeData
);
export const setDocUploadConfig = createAction(Actions.setDocUploadConfig);

export const getMfNominationData = (state) => {
  return get(state, "nominee.mfNominationData", {});
};

export const getEquityNominationData = (state) => {
  return get(state, "nominee.equityNominationData", {});
};

export const getNomineeDetails = (state) => {
  return get(state, "nominee.nomineeDetails", {});
};

export const getNomineeStorage = (state) => {
  return get(state, "nominee.nomineeStorage", {});
};

export const getIsDocumentRequired = (state) => {
  return get(state, "nominee.isDocumentRequired", false);
};

const initialState = {
  mfNominationData: {},
  equityNominationData: {},
  nomineeDetails: {
    ...DEFAULT_NOMINEE_PERSONAL_DETAILS,
    ...DEFAULT_NOMINEE_ADDRESS_DETAILS,
  },
  nomineeStorage: {
    showEsignFailure: false,
  },
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setNominations, (state, action) => {
    const { mfNominationData, equityNominationData } = action.payload;
    state.mfNominationData = mfNominationData;
    state.equityNominationData = equityNominationData;
  });
  builder.addCase(updateNomineeDetails, (state, action) => {
    state.nomineeDetails = { ...state.nomineeDetails, ...action.payload };
  });
  builder.addCase(resetNomineeDetails, (state) => {
    state.nomineeDetails = {};
  });
  builder.addCase(updateEquityNomineeData, (state, action) => {
    state.equityNominationData = {
      ...state.equityNominationData,
      ...action.payload,
    };
  });
  builder.addCase(updateNomineeStorage, (state, action) => {
    state.nomineeStorage = {
      ...state.nomineeStorage,
      ...action.payload,
    };
  });
  builder.addCase(resetNomineeStorage, (state) => {
    state.nomineeStorage = {};
  });
  builder.addCase(setDocUploadConfig, (state, action) => {
    state.isDocumentRequired = action.payload;
  });
});
